export default __webpack_public_path__ + "static/media/avatar_placeholder-2.f75e06ba.png";